module.exports = __webpack_public_path__ + "static/img/black-board-middle.2d151eff.jpg";